import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { AddrInputService } from './addr-input.service';
@Component({
  selector: 'app-addr-input',
  templateUrl: './addr-input.component.html',
  styleUrls: ['./addr-input.component.scss'],
  providers: [AddrInputService],
})
export class AddrInputComponent implements OnInit {
  @Input() display = false; //模态显示隐藏
  @Input() keyword:string;//搜索关键字
  @Output() getkeyWords: any = new EventEmitter();   //  提供关键字
  @Output() getHotkeyWords: any = new EventEmitter();//提供热门关键字

  public isShow: boolean = false;   
  public titleCity: string = "城市";   //选择的城市
  // public keyword: string;//搜索关键字
  public hotWord: Array<Object> = []; //热门关键字列表
  constructor(private _addrIputService: AddrInputService) { }

  ngOnInit() {
    // 热门岗位关键字列表
    this.getHotWorld();
  }
  //关键字
  getKeyWorld() {
    this.getkeyWords.emit(this.keyword); //返回将要查找的关键字
  }
  // 热门岗位关键字列表
  getHotWorld() {
    this._addrIputService.getHotKeyWorld().then(resp => { //获取热门关键字列表
      if (resp.success) {
        this.hotWord = resp['data'];
      } else {
        alert(resp['msg']);
      }
    })
  }
  //获取被选中的岗位 
  gethotword($event) {
    this.getHotkeyWords.emit($event);
  }
  //打开或关闭模态框状态  显示是true  关闭是false
  showDialog() {
    this.display = true;
  }
  //获取模态框状态  显示是true  关闭是false
  dialogShow($evnet) {
    this.display ? this.display = false : this.display = true;
    // console.log("deo", $evnet);
  }
  //获取选中的城市信息
  getCityData($event) {
    this.titleCity = $event.name;
    this.keyword = this.titleCity
    // console.log($event);
  }
}



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/shared/addr-input/addr-input.component.ts